import { useEffect, useRef } from 'react'

import { DEFAULT_ICON_SIZE } from './constants'

export const CustomPicker = <T,>({
  onEmojiSelect,
  i18n,
  locale,
  previewPosition = 'none',
  skinTonePosition = 'none',
  theme = 'auto',
  emojiSize = DEFAULT_ICON_SIZE,
  custom
}: Omit<CustomPickerProps<T>, 'ref'>) => {
  const ref = useRef(null)
  const showEmojis = useRef(true)

  useEffect(() => {
    if (showEmojis.current) {
      showEmojis.current = false

      window?.registerPicker?.({
        ref,
        onEmojiSelect,
        i18n,
        locale,
        previewPosition,
        skinTonePosition,
        theme,
        emojiSize,
        custom
      }) ?? console.error('error: init emoji-picker')
    }
  }, [emojiSize, locale, onEmojiSelect, i18n, previewPosition, skinTonePosition, theme, custom])

  return <div ref={ref}></div>
}
